import axios from "axios";

import { baseAxios } from "config";
import createApiParams from "utils/createApiParams";

const searchJobsWithAI = async ({
  applicantId,
  page,
  limit,
  order,
  orderBy,
  filters,
  geoPreference,
  geoRadius,
  filterPayMin,
  filterPayMax,
  venues,
  companyType = "Venue",
  outsideMode = "",
}) => {
  if (
    filters &&
    Object.prototype.hasOwnProperty.call(filters, "venueSlug") &&
    companyType === "Venue" &&
    filters.venueSlug === undefined
  )
    return null;

  const outsideModeQuery = !outsideMode ? "" : `outside-${outsideMode}/`;

  const res = await baseAxios.post(`/${outsideModeQuery}jobs/applicants/${applicantId}/search`, {
    filter: filters,
    orderBy,
    order: orderBy === "distance" ? "asc" : "desc",
    geoPreference,
    geoRadius,
    filterPayMin,
    filterPayMax,
  });

  if (res?.data?.data?.length) {
    const retData = res.data.data.map((job) => {
      return {
        ...job,
        ...(companyType === "Venue"
          ? {
              logoUrl: venues?.[job?.venueSlug]?.logoUrl,
              venueName: venues?.[job?.venueSlug]?.name,
            }
          : {}),
      };
    });
    res.data = { ...res.data, data: [...retData] };
  }

  return res.data;
};

export default searchJobsWithAI;
